<template>
  <h1>供應商</h1>
</template>

<script>
export default {}
</script>

<style></style>
